import { useSearchParams } from 'react-router-dom';
import { Building2, UserCircle } from 'lucide-react';
import { WatchlistSubNav } from '@/components/watchlist/SubNav';
import { wl } from '@/components/watchlist/theme';
import { BrandsPanel } from './brands';
import { VipsPanel } from './vips';

type ProfileType = 'brand' | 'vip';

export default function ProfilesPage() {
  const [params, setParams] = useSearchParams();
  const type: ProfileType = params.get('type') === 'vip' ? 'vip' : 'brand';

  function setType(t: ProfileType) {
    setParams(t === 'brand' ? {} : { type: t });
  }

  return (
    <div style={{ background: wl.bg, minHeight: '100%' }} className="flex flex-col -m-6 p-6">
      <WatchlistSubNav />

      <div className="flex items-center gap-1 mb-6" style={{ background: wl.surface, border: `1px solid ${wl.border}`, borderRadius: 8, padding: 4, width: 'fit-content' }}>
        {([['brand', 'Brand', Building2], ['vip', 'VIP', UserCircle]] as const).map(([t, label, Icon]) => (
          <button
            key={t}
            onClick={() => setType(t)}
            className="flex items-center gap-2 px-4 py-2 rounded font-semibold transition-colors"
            style={{
              color: type === t ? wl.green : wl.textMuted,
              background: type === t ? wl.greenWash : 'transparent',
              fontSize: 12.5, fontFamily: wl.font,
            }}
          >
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>

      {type === 'brand' ? <BrandsPanel /> : <VipsPanel />}
    </div>
  );
}
